<script setup lang="ts">
defineProps<{ open: boolean; size?: '_svg20' | '_svg16' | '_svg14' | '_svg12' }>()
</script>

<template>
  <svg :class="[$style.v2, size || '_svg20', open && 'on']" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7526 16.1399L17.5488 10.6585C18.1146 10.0119 17.6554 9 16.7962 9L7.20377 9C6.34461 9 5.88543 10.0119 6.45119 10.6585L11.2474 16.1399C11.6458 16.5952 12.3542 16.5952 12.7526 16.1399Z"
      fill="currentColor"
    />
  </svg>
</template>

<style module>
.v2 {
  transition: transform 360ms ease;
}
.v2:global(.on) {
  transform: rotate(0.5turn);
}
</style>
